import { Button } from 'components/ui/button';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import SaveImageModal from '../components/modals/SaveImageModal';
import { useUpscaleImageContext } from '../provider';

export default function GeneratedImageResult() {
  const { generatedImage, selectedImage } = useUpscaleImageContext();

  const handleDownloadImage = async () => {
    try {
      // Handle both data URLs and regular URLs
      let blob;
      if (generatedImage?.startsWith('data:')) {
        // Convert data URL to blob
        const response = await fetch(generatedImage);
        blob = await response.blob();
      } else {
        // Fetch image from URL
        if (!generatedImage) return;

        const response = await fetch(generatedImage);
        blob = await response.blob();
      }

      // Create download URL
      const downloadUrl = window.URL.createObjectURL(blob);

      // Create download link
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = selectedImage?.name || 'upscaled.png';

      // Trigger download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Error downloading image:', error);
      // You might want to show an error message to the user here
    }
  };

  return (
    <div className="col-span-9 h-fit md:h-full w-full gap-4">
      <div className="bg-background h-fit md:h-full text-text-primary w-full col-span-9 overflow-auto  rounded-md">
        <div className="p-3 px-4 border-b flex items-center gap-2">
          <Link
            to={'/upscale-image/get-started'}
            className="flex  items-center gap-3"
          >
            <ArrowLeftIcon className="text-primary" size={20} />
          </Link>
          <div className="flex items-center gap-2 text-xs lg:text-2xl">
            <p className="font-medium text-text-secondary">
              Image Generator{' / '}
            </p>
            <p className="font-medium">{selectedImage?.name}</p>
          </div>

          <div className="hidden lg:flex items-center gap-4 ml-auto">
            <Button
              variant={'customSecondary'}
              size="sm"
              className="bg-secondary"
              onClick={handleDownloadImage}
            >
              Export
            </Button>
            <SaveImageModal generatedImage={generatedImage} />
          </div>
        </div>

        <div className="min-h-[200px] p-4 lg:p-12 w-full flex items-center justify-center ">
          <img
            src={generatedImage ?? ''}
            className="w-full lg:max-w-[50vw] h-auto object-cover rounded-md"
          />
        </div>
      </div>
    </div>
  );
}
